import React from "react";

function ContextDevTool({
  id,
  context: Context,
  displayName
}) {
  return React.createElement(Context.Consumer, null, values => {
    if (typeof window !== 'undefined' && window._REACT_CONTEXT_DEVTOOL) {
      window._REACT_CONTEXT_DEVTOOL({
        id,
        displayName,
        values
      });
    }

    return null;
  });
}

export default ContextDevTool;